<template>
    <div class="container" role="tablist">
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="text-nowrap font-weight-bold m-0">Tickets Page Content</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue v-b-toggle.ticket-page-content icon="eye"
                                  class="pointer"></icon-vue>
                    </div>
                    <b-collapse visible ref="collapse" class="mt-3 col-12" id="ticket-page-content"
                                accordion="accordion-1">
                        <hr>
                        <div>
                            <b-form @submit.prevent="updateData(dbRefs.ticketsRef, ticketsContent)">
                                <b-form-group id="grp-title"
                                              label="Page Heading"
                                              label-for="input-title"
                                              description="This is text that appears atop the about page">
                                    <b-form-input
                                            id="input-title"
                                            v-model="ticketsContent.title"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group id="grp-subtitle"
                                              label="Page Sub-Heading"
                                              label-for="input-subtitle"
                                              description="This is text that appears below the heading">
                                    <b-form-input
                                            id="input-subtitle"
                                            v-model="ticketsContent.subtitle"
                                    ></b-form-input>
                                </b-form-group>

                                <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                          :disabled="saving">
                                    Save
                                </b-button>
                            </b-form>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
        <b-collapse ref="disCollapse"
                    id="disCollapse"
                    class="row no-gutters mb-5"
                    accordion="accordion-1"
                    v-model="showDisCollapse">
            <div class="col-12 col-sm-8 offset-sm-2 border rounded p-3">
                <div class="mb-2 d-flex justify-content-between">
                    <h5>{{!toBeEditedDis ? 'Add' : 'Edit'}} a Disclaimer</h5>
                    <icon-vue
                            class="pointer text-danger"
                            icon="times-circle"
                            @click="showDisCollapse = false"
                    ></icon-vue>
                </div>
                <div>
                    <b-form @submit.prevent="saveDisclaimer">
                        <b-form-group id="grp-dis"
                                      label="Description"
                                      label-for="input-dis">
                            <b-form-textarea
                                    id="input-dis"
                                    v-model="newDisclaimer"
                                    rows="6"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                  :disabled="saving">
                            Save
                        </b-button>
                    </b-form>
                </div>
            </div>
        </b-collapse>
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="font-weight-bold m-0 text-nowrap">Disclaimers</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue icon="plus-circle" class="pointer mr-3 text-success"
                                  @click="showDisCollapse = true"></icon-vue>
                        <icon-vue v-b-toggle.dirs icon="eye" class="pointer"></icon-vue>
                    </div>
                    <b-collapse ref="dirs" class="mt-3 col-12" id="dirs" accordion="accordion-1">
                        <hr>
                        <div v-for="(disclaimer, index) in ticketsContent.disclaimers" :key="index"
                             class="text-secondary p-2 border-bottom position-relative">
                            <div class="position-absolute actions">
                                <icon-vue :icon="['far', 'edit']" class="pointer mr-3"
                                          @click="editDis(disclaimer)"></icon-vue>
                                <icon-vue
                                        class="pointer text-danger"
                                        icon="trash"
                                        @click="deleteDisclaimer(dbRefs.ticketsRef, 'disclaimers', disclaimer)"></icon-vue>
                            </div>
                            <small class="w-80 d-block">{{disclaimer}}</small>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
  import { EventBus } from '../../eventBus';
  import { defaultTicketContent } from '../../utils/content';
  import DataStreamListener from '../../mixins/dataListener';
  import AddDataHandler from '../../mixins/genericAddDataHandler';

  export default {
    data(){
      return {
        ticketsContent: { ...defaultTicketContent },
        showDisCollapse: false,
        toBeEditedDis: '',
        newDisclaimer: ''
      };
    },
    mixins: [DataStreamListener, AddDataHandler],
    methods: {
      async saveDisclaimer(){
        let target = null;
        try{
          target = window.event.target.querySelector('button');
          this.showLoader(target);
          if(!this.toBeEditedDis){
            await this.saveToArray({ ...this.editDisPayload, value: this.newDisclaimer, resetForm: false });
            this.newDisclaimer = '';
            return true;
          }
          await this.updateDisclaimer();
        }catch(e){
          this.$toasted.error(e.message || 'Something went wrong');
        }finally{
          this.hideLoader(target);
        }
      },
      editDis(dis){
        this.newDisclaimer = dis;
        this.toBeEditedDis = dis;
        this.showDisCollapse = true;
      },
      async updateDisclaimer(){
        const payload = {
          ...this.editDisPayload,
          beforeVal: this.toBeEditedDis,
          afterVal: this.newDisclaimer
        };
        await this.updateArrayElem(payload);
        this.newDisclaimer = '';
        this.showDisCollapse = false;
      },
      async deleteDisclaimer(ref, key, value){
        await this.removeFromArray({ ref, key, value });
      }
    },
    computed: {
      editDisPayload(){
        return {
          ref: this.dbRefs.ticketsRef,
          key: 'disclaimers'
        };
      }
    },
    watch: {
      showDisCollapse: function(newValue, oldValue){
        if(!newValue){
          this.toBeEditedDis = '';
          this.newDisclaimer = '';
        }
      }
    },
    async mounted(){
      this.fetchSingleData(this.dbRefs.ticketsRef, defaultTicketContent);
      EventBus.$on('dataFetched', ticketsContent =>{
        this.ticketsContent = ticketsContent;
        setTimeout(() =>{
          this.fetching = false;
        }, 1000);
      });
    }
  };
</script>

<style lang="scss" scoped>
    .actions {
        right: 0;
    }
</style>